<template>
  <span class="box-container">
    <div v-if="!IEMode">
      <v-autocomplete
        v-model="selectedAgent"
        :items="searchableNames"
        placeholder="Search..."
        light
        dense
        clearable
        hide-no-data
        hide-details
        @change="onSelect"
        id="selectedAgent"
        height="75"
        background-color="white"
        style="
        margin-left: 20px;
        border-radius: 4px;
        width: 270px;
        margin-bottom: 0px;
      "
      >
        <template v-slot:selection="{ item }">
          <div
            id="selectionSlotDiv"
            style="padding-left: 3px; padding-right: 3px"
            :style="getOffset()"
          >
            <div class="drag-item-text-selection">
              <span
                style="font-size: 0.9rem; padding-top: 2px; padding-bottom: 2px"
              >
                <div
                  id="selectedName"
                  name="selectedName"
                  :style="
                    isRevoked(item.value)
                      ? 'color:red'
                      : item.terminationDate && item.terminationDate != ''
                      ? 'color:orange;font-weight:bold;'
                      : item.newFlag
                      ? 'color:green'
                      : ''
                  "
                >
                  {{ item.text }}
                </div>
                <span>
                  <template v-if="isEditMode">
                    <template v-if="!isAA(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.stop="
                              raiseSearchBoxEventSel($event, 'moveMember', item)
                            "
                          >
                            mdi-account-switch
                          </v-icon>
                        </template>
                        <span>Move Agent</span>
                      </v-tooltip>
                    </template>

                    <!-- Remove -->
                    <template
                      v-if="
                        (!isRevoked(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)) ||
                          (!isUnAssigned(item.value) &&
                            (!isAOorAA(item) || isHomeOfficeUser))
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.prevent.stop="
                              !isUnAssigned(item.value)
                                ? raiseSearchBoxEventSel(
                                    $event,
                                    'checkForDelete',
                                    item
                                  )
                                : raiseSearchBoxEventSel(
                                    $event,
                                    'checkForRevoke',
                                    item
                                  )
                            "
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span
                          ><template v-if="!isUnAssigned(item.value)"
                            >Remove From Hierarchy or Revoke Access</template
                          >
                          <template v-else>Revoke Access</template></span
                        >
                      </v-tooltip>
                    </template>

                    <!-- Details -->
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>

                    <!-- Replace -->
                    <template
                      v-if="
                        !isUnAssigned(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'replacePosition',
                                item
                              )
                            "
                          >
                            mdi-account-convert
                          </v-icon>
                        </template>
                        <span>Replace Position In Hierarchy</span>
                      </v-tooltip>
                    </template>

                    <!-- Create Office -->
                    <template v-if="item.levelOrder == 2 && !isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'createOffice',
                                item
                              )
                            "
                            size="25"
                            style="margin-right: 4px"
                            >mdi-home-plus</v-icon
                          >
                        </template>
                        <span>Create New Office</span>
                      </v-tooltip>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                  </template>
                </span>
                <span>
                  <!-- Restore Access -->
                  <template v-if="isEditMode && isRevoked(item.value)">
                    <v-tooltip top color="#00558c">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="red"
                          size="25"
                          style="margin-right: 4px"
                          v-bind="attrs"
                          v-on="on"
                          @click.prevent.stop="
                            raiseSearchBoxEventSel(
                              $event,
                              'restoreMemberAccess',
                              item
                            )
                          "
                        >
                          mdi-alert
                        </v-icon>
                      </template>
                      <span>Restore Access</span>
                    </v-tooltip>
                  </template>
                </span>
                <span>
                  <template>
                    <v-tooltip top color="#00558C">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          @click.prevent.stop="
                            raiseSearchBoxEventSel($event, 'navigate', item)
                          "
                          size="25"
                          style="margin-right: 4px"
                          >mdi-compass-rose</v-icon
                        >
                      </template>
                      <span>Navigate</span>
                    </v-tooltip>
                  </template>
                </span>
              </span>
            </div>
          </div>
        </template>

        <!-- items -->

        <template v-slot:item="{ item }">
          <v-list-item-content class="itemSlot">
            <div class="drag-item-text">
              <span style="font-size: 0.8rem">
                <span
                  @click="setSelectionSlotVisible"
                  :style="
                    isRevoked(item.value)
                      ? 'color:red'
                      : item.terminationDate && item.terminationDate != ''
                      ? 'color:orange;font-weight:bold;'
                      : item.newFlag
                      ? 'color:green'
                      : ''
                  "
                  class="itemText"
                >
                  {{ item.text }}
                </span>
                <span>
                  <template v-if="isEditMode">
                    <template v-if="!isAA(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.stop="
                              raiseSearchBoxEventSel($event, 'moveMember', item)
                            "
                          >
                            mdi-account-switch
                          </v-icon>
                        </template>
                        <span>Move Agent</span>
                      </v-tooltip>
                    </template>

                    <!-- Remove -->
                    <template
                      v-if="
                        (!isRevoked(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)) ||
                          (!isUnAssigned(item.value) &&
                            (!isAOorAA(item) || isHomeOfficeUser))
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.prevent.stop="
                              !isUnAssigned(item.value)
                                ? raiseSearchBoxEventSel(
                                    $event,
                                    'checkForDelete',
                                    item
                                  )
                                : raiseSearchBoxEventSel(
                                    $event,
                                    'checkForRevoke',
                                    item
                                  )
                            "
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span
                          ><template v-if="!isUnAssigned(item.value)"
                            >Remove From Hierarchy or Revoke Access</template
                          >
                          <template v-else>Revoke Access</template></span
                        >
                      </v-tooltip>
                    </template>

                    <!-- Details -->
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>

                    <!-- Replace -->
                    <template
                      v-if="
                        !isUnAssigned(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'replacePosition',
                                item
                              )
                            "
                          >
                            mdi-account-convert
                          </v-icon>
                        </template>
                        <span>Replace Position In Hierarchy</span>
                      </v-tooltip>
                    </template>

                    <!-- Create Office -->
                    <template v-if="item.levelOrder == 2 && !isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'createOffice',
                                item
                              )
                            "
                            size="25"
                            style="margin-right: 4px"
                            >mdi-home-plus</v-icon
                          >
                        </template>
                        <span>Create New Office</span>
                      </v-tooltip>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                  </template> </span
                ><span>
                  <!-- Restore Access -->
                  <template v-if="isEditMode && isRevoked(item.value)">
                    <v-tooltip top color="#00558c">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="red"
                          size="25"
                          style="margin-right: 4px"
                          v-bind="attrs"
                          v-on="on"
                          @click.prevent.stop="
                            raiseSearchBoxEventSel(
                              $event,
                              'restoreMemberAccess',
                              item
                            )
                          "
                        >
                          mdi-alert
                        </v-icon>
                      </template>
                      <span>Restore Access</span>
                    </v-tooltip>
                  </template>
                </span>
              </span>
            </div>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </div>
    <div v-else>
      <!-- IEMode -->
      <v-select
        v-model="selectedAgent"
        :items="searchableNames"
        placeholder="Search..."
        light
        dense
        clearable
        hide-no-data
        hide-details
        @change="onSelect"
        id="selectedAgent"
        height="75"
        background-color="white"
        style="
        margin-left: 20px;
        border-radius: 4px;
        width: 270px;
        margin-bottom: 0px;
      "
      >
        <template v-slot:selection="{ item }">
          <div
            id="selectionSlotDiv"
            style="padding-left: 3px; padding-right: 3px"
            :style="getOffset()"
          >
            <div class="drag-item-text-selection">
              <span
                style="font-size: 0.9rem; padding-top: 2px; padding-bottom: 2px"
              >
                <div
                  id="selectedName"
                  name="selectedName"
                  :style="
                    isRevoked(item.value)
                      ? 'color:red'
                      : item.terminationDate && item.terminationDate != ''
                      ? 'color:orange;font-weight:bold;'
                      : item.newFlag
                      ? 'color:green'
                      : ''
                  "
                >
                  {{ item.text }}
                </div>
                <span>
                  <template v-if="isEditMode">
                    <template v-if="!isAA(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.stop="
                              raiseSearchBoxEventSel($event, 'moveMember', item)
                            "
                          >
                            mdi-account-switch
                          </v-icon>
                        </template>
                        <span>Move Agent</span>
                      </v-tooltip>
                    </template>

                    <!-- Remove -->
                    <template
                      v-if="
                        (!isRevoked(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)) ||
                          (!isUnAssigned(item.value) &&
                            (!isAOorAA(item) || isHomeOfficeUser))
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.prevent.stop="
                              !isUnAssigned(item.value)
                                ? raiseSearchBoxEventSel(
                                    $event,
                                    'checkForDelete',
                                    item
                                  )
                                : raiseSearchBoxEventSel(
                                    $event,
                                    'checkForRevoke',
                                    item
                                  )
                            "
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span
                          ><template v-if="!isUnAssigned(item.value)"
                            >Remove From Hierarchy or Revoke Access</template
                          >
                          <template v-else>Revoke Access</template></span
                        >
                      </v-tooltip>
                    </template>

                    <!-- Details -->
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>

                    <!-- Replace -->
                    <template
                      v-if="
                        !isUnAssigned(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'replacePosition',
                                item
                              )
                            "
                          >
                            mdi-account-convert
                          </v-icon>
                        </template>
                        <span>Replace Position In Hierarchy</span>
                      </v-tooltip>
                    </template>

                    <!-- Create Office -->
                    <template v-if="item.levelOrder == 2 && !isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'createOffice',
                                item
                              )
                            "
                            size="25"
                            style="margin-right: 4px"
                            >mdi-home-plus</v-icon
                          >
                        </template>
                        <span>Create New Office</span>
                      </v-tooltip>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                  </template>
                </span>
                <span>
                  <!-- Restore Access -->
                  <template v-if="isEditMode && isRevoked(item.value)">
                    <v-tooltip top color="#00558c">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="red"
                          size="25"
                          style="margin-right: 4px"
                          v-bind="attrs"
                          v-on="on"
                          @click.prevent.stop="
                            raiseSearchBoxEventSel(
                              $event,
                              'restoreMemberAccess',
                              item
                            )
                          "
                        >
                          mdi-alert
                        </v-icon>
                      </template>
                      <span>Restore Access</span>
                    </v-tooltip>
                  </template>
                </span>
                <span>
                  <template>
                    <v-tooltip top color="#00558C">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          @click.prevent.stop="
                            raiseSearchBoxEventSel($event, 'navigate', item)
                          "
                          size="25"
                          style="margin-right: 4px"
                          >mdi-compass-rose</v-icon
                        >
                      </template>
                      <span>Navigate</span>
                    </v-tooltip>
                  </template>
                </span>
              </span>
            </div>
          </div>
        </template>

        <!-- items -->

        <template v-slot:item="{ item }">
          <v-list-item-content class="itemSlot">
            <div class="drag-item-text">
              <span style="font-size: 0.8rem">
                <span
                  @click="setSelectionSlotVisible"
                  :style="
                    isRevoked(item.value)
                      ? 'color:red'
                      : item.terminationDate && item.terminationDate != ''
                      ? 'color:orange;font-weight:bold;'
                      : item.newFlag
                      ? 'color:green'
                      : ''
                  "
                  class="itemText"
                >
                  {{ item.text }}
                </span>
                <span>
                  <template v-if="isEditMode">
                    <template v-if="!isAA(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.stop="
                              raiseSearchBoxEventSel($event, 'moveMember', item)
                            "
                          >
                            mdi-account-switch
                          </v-icon>
                        </template>
                        <span>Move Agent</span>
                      </v-tooltip>
                    </template>

                    <!-- Remove -->
                    <template
                      v-if="
                        (!isRevoked(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)) ||
                          (!isUnAssigned(item.value) &&
                            (!isAOorAA(item) || isHomeOfficeUser))
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.native.prevent.stop="
                              !isUnAssigned(item.value)
                                ? raiseSearchBoxEventSel(
                                    $event,
                                    'checkForDelete',
                                    item
                                  )
                                : raiseSearchBoxEventSel(
                                    $event,
                                    'checkForRevoke',
                                    item
                                  )
                            "
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span
                          ><template v-if="!isUnAssigned(item.value)"
                            >Remove From Hierarchy or Revoke Access</template
                          >
                          <template v-else>Revoke Access</template></span
                        >
                      </v-tooltip>
                    </template>

                    <!-- Details -->
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>

                    <!-- Replace -->
                    <template
                      v-if="
                        !isUnAssigned(item.value) &&
                          (!isAOorAA(item) || isHomeOfficeUser)
                      "
                    >
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="initial"
                            size="25"
                            style="margin-right: 4px"
                            v-bind="attrs"
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'replacePosition',
                                item
                              )
                            "
                          >
                            mdi-account-convert
                          </v-icon>
                        </template>
                        <span>Replace Position In Hierarchy</span>
                      </v-tooltip>
                    </template>

                    <!-- Create Office -->
                    <template v-if="item.levelOrder == 2 && !isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            @click.prevent.stop="
                              raiseSearchBoxEventSel(
                                $event,
                                'createOffice',
                                item
                              )
                            "
                            size="25"
                            style="margin-right: 4px"
                            >mdi-home-plus</v-icon
                          >
                        </template>
                        <span>Create New Office</span>
                      </v-tooltip>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="!isABL(item)">
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : 'initial'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 4px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top color="#00558C">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="item.newFlag == true ? 'green' : '#4682b4'"
                            v-bind="attrs"
                            v-on="on"
                            size="25"
                            style="margin-right: 5px"
                            type="button"
                            @submit.stop=""
                            @click.stop="
                              raiseSearchBoxEventSel($event, 'getDetails', item)
                            "
                            >mdi-account-star</v-icon
                          >
                        </template>
                        <span v-if="item.newFlag == true">New!</span>
                        <span v-else>Details</span>
                      </v-tooltip>
                    </template>
                  </template> </span
                ><span>
                  <!-- Restore Access -->
                  <template v-if="isEditMode && isRevoked(item.value)">
                    <v-tooltip top color="#00558c">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="red"
                          size="25"
                          style="margin-right: 4px"
                          v-bind="attrs"
                          v-on="on"
                          @click.prevent.stop="
                            raiseSearchBoxEventSel(
                              $event,
                              'restoreMemberAccess',
                              item
                            )
                          "
                        >
                          mdi-alert
                        </v-icon>
                      </template>
                      <span>Restore Access</span>
                    </v-tooltip>
                  </template>
                </span>
              </span>
            </div>
          </v-list-item-content>
        </template>
      </v-select>
    </div>
  </span>
</template>
<script>
import EventBus from "@/eventBus.js";
import $j from "jquery";
import utilityMixins from "@/utility-mixins.js";

export default {
  mixins: [utilityMixins],
  name: "AgentSearchBox",
  props: ["searchableAgents", "isEditMode", "sortedAgentPool", "revokedAgents"],
  data() {
    return {
      initial: "dark grey",
      selectedAgent: null,
      IEMode: false
    };
  },
  beforeDestroy() {
    this.$off("setVisibility", this.setSelectionSlotVisible);
    // EventBus.$off("blankAgentSearch");
  },

  created() {
    if (window.document.documentMode) {
      this.IEMode = true;
    }
  },

  mounted() {
    if (window.document.documentMode) {
      this.IEMode = true;
    }

    this.$on("setVisibility", this.setSelectionSlotVisible);

    // var self = this;
    let el = document.getElementById("selectedAgent");
    if (el) {
      el.onkeydown = function(event) {
        var code;

        if (event.key !== undefined) {
          code = event.key;
        } else if (event.keyIdentifier !== undefined) {
          code = event.keyIdentifier;
        } else if (event.keyCode !== undefined) {
          code = event.keyCode;
        }
        if (code.indexOf("Enter") < 0) {
          var ssd = document.getElementById("selectionSlotDiv");
          if (ssd) {
            var els = document.getElementsByClassName(
              "v-icon notranslate v-icon--link mdi mdi-close theme--light primary--text"
            );
            // let value = el.value;
            els[0].click();
            // self.$nextTick(function () {
            //   let el = document.getElementById("selectedAgent");

            //   this.selectedAgent = value;

            // });
          }
          return true;
        }
      };
    }
  },
  computed: {
    searchableNames() {
      let names = [];
      this.searchableAgents.forEach(agent => {
        names.push(agent);
      });
      return names;
    }
  },
  methods: {
    onSelect() {
      $j("div").removeClass("highlight");

      let selected = this.searchableAgents.find(
        sa => sa.memberInfo.id == this.selectedAgent
      );

      this.raiseSearchBoxEvent("navigate", selected);
    },
    setSelectionSlotVisible() {
      this.$nextTick(function() {
        var ssd = document.getElementById("selectionSlotDiv");
        if (ssd) ssd.style.visibility = "visible";
      });
      return true;
    },
    getOffset() {
      if (
        document.getElementById("selectedName") &&
        document.getElementById("selectedName").clientHeight > 20
      )
        return "margin-bottom: -30px;";
      else return "";
    },
    isAOorAA(agent) {
      if (agent.levelOrder <= 1) {
        return true;
      }
      return false;
    },
    isAA(agent) {
      if (agent.levelOrder == 1) {
        return true;
      }
      return false;
    },
    isABL(agent) {
      if (agent.levelOrder == 3) {
        return true;
      }
      return false;
    },
    isUnAssigned(id) {
      if (this.sortedAgentPool.findIndex(agent => agent.id == id) >= 0) {
        return true;
      }
      return false;
    },
    isRevoked(id) {
      if (this.revokedAgents.findIndex(ra => ra.id == id) >= 0) {
        return true;
      }
      return false;
    },
    raiseSearchBoxEvent(action, agent) {
      let data = { agent: agent, action: action };
      EventBus.$emit("searchBoxAction", data);

      return false;
    },
    raiseSearchBoxEventSel(event, action, agent) {
      let data = { agent: agent, action: action };
      EventBus.$emit("searchBoxAction", data);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }
};
</script>
<style scoped>
.box-container {
  width: 100%;
  height: 55px;

  width: 290px !important;
  max-width: 325px !important;
  margin-right: 0px;
  padding-right: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  width: 285px;
  border: 3px 3px 3px 3px blue !important;
}
.drag-item-text {
  font-size: 0.95rem;
  padding-left: 1rem;
  min-width: 375px;
}
.drag-item-text-selection {
  font-size: 0.95rem;
  padding-left: 5px;
}
/* .v-input__control {
  max-height: 55px;
}
.v-input__slot[role="combobox"] {
  background-color: white;
}
.v-input--hide-details > .v-input__control > .v-input__slot {
  margin-left: 0px;
}
.v-select__slot {
  max-width: 200px;
}
.v-select__selections {
  min-width: 200px; 
}*/
</style>
